// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pro8JDM1mt9iESrLNVCD{display:flex;align-items:center;gap:8px}.BFJB6JHuMK4WK5U7sTvw{width:8px;height:8px;border-radius:50%;flex-shrink:0}`, "",{"version":3,"sources":["webpack://./src/pages/analytics/ui/BreakdownEntityCell/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,YAAA,CACA,kBAAA,CACA,OAAA,CAGF,sBACE,SAAA,CACA,UAAA,CACA,iBAAA,CACA,aAAA","sourcesContent":[".cell {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.tagColor {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cell": `pro8JDM1mt9iESrLNVCD`,
	"tagColor": `BFJB6JHuMK4WK5U7sTvw`
};
export default ___CSS_LOADER_EXPORT___;
